import { useEffect, useState } from "react";
import { formatDate } from "../../../../../../../../common/helpers/date.helpers";
import { formatCurrency } from "../../../../../../../../common/helpers/mask.helpers";
import { BILLING_TYPE, PaymentInfo } from "../../../../../../../../types/payment.type";
import { IRenter } from "../../../../../../../../types/renter.type";
import { getPartnersById } from "../../../../../../../../common/services/partners.api";

interface useReactivationNegotiationProps {
  renter: IRenter;
  payments: PaymentInfo[];
}
export function useReactivationNegotiation({ renter, payments }: useReactivationNegotiationProps) {

  const [vehicleOwnerCompany, setVehicleOwnerCompany] = useState<string | undefined>(undefined);

  let unlinkDate;
  let licensePlate;
  let planName;
  let planValue;
  let vehicleOwnerId;
  const mostRecentPaymentOverdueDate: string[] = [];
  const paymentId: string[] = [];
  const planValueAmout: number[] = [];
  let overdueWeeksValue = 0;
  let numberPaymentOverdue = 0;
  let rentalStartDate;
  let percentualValueSplit = 0;


  const vehicleHistory = renter?.desactivationData?.vehicleHistory || [];
  const planHistoryData = renter?.desactivationData?.planHistory || [];

  // Filtra os itens que têm, por exemplo, a propriedade 'vehicleHistoryEnd' definida
  const populatedHistoryVehicle = vehicleHistory.filter(
    (item) => item.id !== ""
  );


  if (populatedHistoryVehicle.length > 0) {
    const lastVehicleHistory = populatedHistoryVehicle[populatedHistoryVehicle.length - 1];
    unlinkDate = formatDate(lastVehicleHistory.vehicleHistoryEnd);
    licensePlate = lastVehicleHistory.licensePlate;
    vehicleOwnerId = lastVehicleHistory.partnerId;
    rentalStartDate = formatDate(lastVehicleHistory.vehicleHistoryInitial);
  }

  useEffect(() => {
    if (vehicleOwnerId) {
      getPartnersById(vehicleOwnerId).then((response) => {
        if (response.ok) {
          setVehicleOwnerCompany(response.data.companyName);
        }
      });
    }
  }, [vehicleOwnerId]);

  const populatedHistoryPlan = planHistoryData.filter((item) => item.label !== "")

  if (populatedHistoryPlan.length > 0) {
    planName = populatedHistoryPlan[populatedHistoryPlan.length - 1].label;
    planValue = formatCurrency(planHistoryData[planHistoryData.length - 1].value)
  }

  if (planHistoryData.length === 0) {
    planName = renter.activationData.plan.label;
    planValue = formatCurrency(renter.activationData.plan.value);
  }


  //filtrar para pegar apenas pagamentos que estao com status de OVERDUE e que tenham a descricao SEMANAL DO PLANO
  const paymentsOverdue = payments.filter((payment) => payment.status === "OVERDUE" && /COBRANÇA REFERENTE A SEMANAL DO PLANO/i.test(payment.description));


  if (paymentsOverdue.length !== 0) {
    for (let i = 0; i < paymentsOverdue.length; i++) {
      const paymentDateOverdue = formatDate(paymentsOverdue[i].dueDate);
      const paymentValuesTotal = paymentsOverdue[i].value;
      if (paymentsOverdue[i].dueDate && unlinkDate && paymentDateOverdue! < unlinkDate) {
        mostRecentPaymentOverdueDate.push(formatDate(paymentsOverdue[i].dueDate));
        paymentId.push(paymentsOverdue[i]._id || "");
        planValueAmout.push(paymentValuesTotal);
        overdueWeeksValue += paymentValuesTotal;
        numberPaymentOverdue++;
        const paymentWithSplit = paymentsOverdue[i].history?.find(hist => hist.data?.split)?.data;
        percentualValueSplit = paymentWithSplit?.split[paymentWithSplit.split - 1]?.percentualValue;

      }
    }
  }

  const gridItems = [
    { label: 'Data de desvinculo da moto  :', value: unlinkDate },
    { label: 'Placa da Moto:', value: licensePlate },
    { label: 'Proprietário:', value: vehicleOwnerCompany },
    { label: 'Data da semanal em atraso:', value: mostRecentPaymentOverdueDate.join(' - ') },
    { label: 'Valor da semanal:', value: planValue },
    { label: 'Plano do cliente:', value: planName },
    { label: 'Valor total da semanal em atraso:', value: formatCurrency(overdueWeeksValue) },
    { label: 'Quantidade de semanal em atraso:', value: numberPaymentOverdue },
    { label: 'Data de início da locação:', value: rentalStartDate },
  ];

  const paymentOptions = [
    { label: "-", value: "" },
    { label: "Cartão de Crédito", value: BILLING_TYPE.CREDIT_CARD },
    { label: "Boleto", value: BILLING_TYPE.BOLETO },
    { label: "Pix", value: BILLING_TYPE.PIX },
  ]


  return {
    unlinkDate,
    licensePlate,
    planName,
    planValue,
    vehicleOwnerCompany,
    mostRecentPaymentOverdueDate,
    paymentId,
    overdueWeeksValue,
    vehicleOwnerId,
    gridItems,
    paymentOptions,
    numberPaymentOverdue,
    percentualValueSplit
  }

}